var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("default",function(){return [_vm._l((_vm.options),function(item,index){return [(item[_vm.idKey] == _vm.value)?_c('span',{key:index,staticClass:"eve-dict-text"},[_vm._v(_vm._s(item[_vm.textKey]))]):_vm._e()]})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }